/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoMinLengthValidator', ['$timeout', function ($timeout) {

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            $timeout(function () {
                var vm = this;

                //validator function
                ctrl.$validators.minLengthValidator = function (modelValue, viewValue) {
                    if (modelValue && attrs.eoMinLengthValidator) {
                        if (modelValue.length < +attrs.eoMinLengthValidator) {
                            return false;
                        } else {
                            return true;
                        }
                    }

                    return true;
                };

            });

        }
    };
}]);
